import {
  ActiveState,
  EntityState,
  EntityStore,
  StoreConfig,
} from '@datorama/akita';
import { Injectable } from '@angular/core';
import { TableColumn } from '../../../models/table-column';
import { TextKeys } from '../../../i18n/text-keys';
import {getMaterialFilterOptions, getTableColumns} from './material-table-columns';
import { MaterialFilterOptionsModel } from '../../../models/material/material-filter-options.model';
import { MaterialModel } from '../../../models/material/material-model';

/**
 * Expenses Entity Store.
 */
export interface MaterialItemsState
  extends EntityState<MaterialModel, number>,
    ActiveState {
  page: number;
  pageSize: number;
  columns: TableColumn[];
  lastPage: boolean;
  filterOptions: MaterialFilterOptionsModel;
  filterValue: string;
  sortKey: string;
  sortDirection: string;
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'material-items', idKey: 'id' })
export class MaterialItemsStore extends EntityStore<MaterialItemsState> {
  constructor() {
    super({
      page: 0,
      pageSize: 50,
      lastPage: false,
      columns: getTableColumns(),
      filterOptions: getMaterialFilterOptions(),
      filterValue: '',
      sortKey: 'Date',
      sortDirection: 'asc',
    });
  }
}
